import type { DataAction } from '../../../types/dataAction.type';
import type { RedirectValue } from '../types';

export const UPDATE_QR_CODE_LINK_ANDROID = 'UPDATE_QR_CODE_LINK_ANDROID' as const;

export const updateQrCodeLinkAndroid = (android: RedirectValue) => ({
  data: { android },
  type: UPDATE_QR_CODE_LINK_ANDROID,
});

export type UpdateQrCodeLinkAndroidResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_ANDROID,
  { android: RedirectValue }
>;
